/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface GrowthModelResponse
 */
export interface GrowthModelResponse {
  /**
   *
   * @type {string}
   * @memberof GrowthModelResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof GrowthModelResponse
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GrowthModelResponse
   */
  type: GrowthModelResponseTypeEnum;
  /**
   *
   * @type {string}
   * @memberof GrowthModelResponse
   */
  version: string | null;
  /**
   *
   * @type {string}
   * @memberof GrowthModelResponse
   */
  adjustmentType: GrowthModelResponseAdjustmentTypeEnum;
  /**
   *
   * @type {Array<number>}
   * @memberof GrowthModelResponse
   */
  adjustment: Array<number>;
  /**
   *
   * @type {string}
   * @memberof GrowthModelResponse
   */
  planId: string;
  /**
   *
   * @type {boolean}
   * @memberof GrowthModelResponse
   */
  isDefault: boolean;
}

export const GrowthModelResponseTypeEnum = {
  SkrettingSalmon: 'skretting-salmon',
  EgiSalmon: 'egi-salmon',
  Sgr: 'sgr',
  Ittt: 'ittt',
} as const;

export type GrowthModelResponseTypeEnum =
  (typeof GrowthModelResponseTypeEnum)[keyof typeof GrowthModelResponseTypeEnum];
export const GrowthModelResponseAdjustmentTypeEnum = {
  Constant: 'constant',
  MonthsSinceRelease: 'months_since_release',
  CalendarYear: 'calendar_year',
} as const;

export type GrowthModelResponseAdjustmentTypeEnum =
  (typeof GrowthModelResponseAdjustmentTypeEnum)[keyof typeof GrowthModelResponseAdjustmentTypeEnum];
